module.exports = __webpack_public_path__ + "static/media/file-text-outline 1.04bc0d55.svg";